import React from 'react';

import {useHistory} from 'react-router-dom';
import {Box, Button, Grid, Typography, withStyles} from '@material-ui/core';

import {functions} from 'commons/utils';
import {InferPropTypes} from 'commons/types/Types';
import {useUserContext} from 'context/user/UserContext';
import {NotFoundStyles} from 'assets/tss/modules/session';
import {HistoryRoutes, INITIAL_MODULES} from 'commons/constants';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {useRelatedPeopleContext} from 'context/related-people-flow/RelatedPeopleFlow';
import {useBeneficiaryContext} from 'context/beneficiary-context/BeneficiaryContext';

function NotFound(props: InferPropTypes<typeof NotFound.propTypes, typeof NotFoundStyles>) {
    const {classes} = props;
    const history = useHistory();

    const {resetUserProvider} = useUserContext();
    const {resetMenuProvider, updateMenu, setFatherKycId, setKycId, setPersonType} =
        useMenuContext();
    const {resetBeneficiaryContext} = useBeneficiaryContext();
    const {resetRelatedPeopleContext} = useRelatedPeopleContext();

    async function handleSubmit() {
        setFatherKycId(0);
        setKycId(-1);
        setPersonType('');
        resetMenuProvider();
        resetUserProvider();
        resetRelatedPeopleContext();
        resetBeneficiaryContext();
        functions.resetUserDataConstant();
        updateMenu([...INITIAL_MODULES]);
        history.push(HistoryRoutes.LOGIN);
    }

    return (
        <div className={classes.root}>
            <Grid container direction='column' alignItems='center'>
                <Grid item xs={6} className={classes.main}>
                    <div className={classes.errorTitle}>{'404'}</div>
                    <Typography variant='h3' color='primary' align='center'>
                        {'Page not found!'}
                    </Typography>
                    <Typography variant='h6' color='secondary' align='center'>
                        {
                            'Its looking like you may have taken a wrong turn. Dont worry... it happens to the best of us.'
                        }
                    </Typography>
                    <Box display={'flex'} justifyContent={'center'}>
                        <Button
                            onClick={handleSubmit}
                            type='submit'
                            disabled={false}
                            color={'primary'}
                            variant={'contained'}>
                            {'Go Home!'}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

NotFound.propTypes = {};

export default withStyles(NotFoundStyles)(NotFound);
